<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">SALIDA HARINA A REPROCESO PLANTA</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>

            </v-card-text>

            <v-row class="ml-1 mr-2 mb-6">
                <EncabezadoMovimientos
                    :bodegasOrigen="bodegasOrigen"
                    :bodegasDestino="bodegasDestino"
                    :tipos="tipos"
                    :motivos="motivos"
                    :bodega_origen="bodega_origen"
                    :bodega_destino="bodega_destino"
                    @cargar-lotes="cargarLotes"
                    @set-data="setDataEncabezado"
                    @cargar-maxisacos="cargarMaxisacos"
                    @cargar-documentos="cargarDocumentos"
                />
            </v-row>
        </v-card>
        <v-row class="ml-2 mr-2" v-if="alert">
            <v-col>
                <v-alert
                    dense
                    text
                    type="success"
                >
                Despacho Generado Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                </v-alert>
            </v-col>
        </v-row>

        <v-row class="ml-1 mr-1">
            <MaxisacosSalida
                    :lotesOrigen="lotes"
                    :loteSelected="lote"
                    :bodegaOrigen="bodega_origen"
                    @lotes-salientes="setLotesSalientes"
                />
            
        </v-row>

        <v-row class="ml-1 mr-1">
            <v-col>
                <v-card>
                    <v-row class="ml-1 mr-1" cols="4">
                        <v-col>
                            <v-autocomplete
                                v-model="maxisaco"
                                :items="maxisacos_lote"
                                item-text="nombre_lote"
                                item-value="id"
                                label="Seleccione Lote"
                                color="blue darken-3"
                                return-object
                                @change="cargarMaxisacosLote($event)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col class="text-center" cols="4">
                            Maxisacos Obtenidos
                        </v-col>
                        <v-col class="text-center" cols="3">
                            <v-text-field
                                label="Lote"
                                v-model="traer_lote"
                            ></v-text-field>
                            <v-btn class="float-right" small dark color="#ff9800" @click="traerMaxisacosLote">
                                <v-icon>info_outline</v-icon> Traer Lote
                            </v-btn>
                        </v-col>
                        <v-col cols="1">
                            <v-btn class="float-right" small dark color="#1565C0" @click="agregar_maxisaco">
                                <v-icon>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-checkbox
                                    v-model="all_repaso"
                                    label="Todos"
                                    color="#0288D1"
                                    class="float-right"
                                    hide-details
                                    @change="seleccionarTodosRepaso"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col v-for="j in maxisacos" :key="j.id">
                                <v-switch v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card>
                    <v-row class="ml-1 mr-1">
                        <v-col>
                            <v-btn small dark color="#1565C0" @click="quitarMaxi">
                                <v-icon>keyboard_arrow_left</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col><p>Maxisacos seleccionados</p></v-col>
                        <v-col>
                            <v-btn dark small rounded class="float-right" color="green darken-1" @click="generarSalida">GRABAR</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-row>
                            <v-col v-for="j in maxisacos_obtenidos" :key="j.id">
                                <v-switch v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <h3>Total Kilos: {{ kilos_obtenidos }}</h3>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
   
</template>
<script>
import { mapState,mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import EncabezadoMovimientos from '@/components/movimientos/EncabezadoMovimientos.vue'
import MaxisacosSalida from '@/components/movimientos/MaxisacosSalida.vue'

export default {
    data:()=>({
        fecha: '',
        lote: {id:''},
        traer_lote: '',
        lotes: [],
        lotesSalientes: [],
        jumbos: [],
        jumbos_repaso: [],
        checkbox_select: false,
        all_repaso: false,
        alert: false,
        bodega_origen: 1,
        bodega_destino: 0,
        tipo: 'S',
        motivo: 4,
        motivos: [],
        tipos: [],
        bodegas: [],
        bodegasOrigen: [],
        bodegasDestino: [],
        datos_adicionales: [],
        maxisaco: {},
        maxisacos: [],
        maxisacos_lote: [],
        maxisacos_obtenidos: []
    }),
    mounted(){
        this.fecha = this.moment().format('YYYY-MM-DD HH:mm');
        this.cargarBodegas();
        this.cargarMotivos();
        this.cargarTipos();
    },
    methods:{
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Salida a Reproceso`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se registran las salidas a reproceso. Se  debe tener el listado de maxisacos que salieron a reproceso y el listado de lotes y maxisacos que se obtuvieron de ese reproceso. `},
                        {   tipo:`label`,   texto:`- Primero se registran los datos generales como la Fecha y lo demás, por defecto debería ser Bodega Origen = Planta La Portada, Bodega Destino = Reproceso en Planta, Tipo Movimiento = Salida y Motivo Movimiento = Reproceso `},
                        {   tipo:`label`,   texto:`- Luego otros datos (documentos, nros de folio) `},
                        {   tipo:`label`,   texto:`- Donde dice Bodega Origen (Seleccione Lote) se buscan los lotes y maxisacos que están disponibles para reproceso ... para seleccionar maxisacos, se busca el lote y se marcan los maxisacos, para luego hacer clic en la flecha azul que apunta hacia la derecha y dejarlos en Bodega Destino `},
                        {   tipo:`label`,   texto:`- Donde dice Maxisacos Obtenidos (Seleccione Lote) se buscan los lotes y maxisacos que se generaron a partir del reproceso. Para seleccionarlos, se marcan y con la flecha azul se pasan a "Maxisacos seleccionados" ... si un maxisaco no aparece porque ya fué despachado, se escribe el número del lote arriba de donde dice "Traer Lote" y se hace clic en ese botón "Traer Lote" (con esto se mostrarán y se podrán seleccionar maxisacos aunque ya no estén en stock) `},
                        {   tipo:`label`,   texto:`- Si se necesita volver un maxisaco desde "Bodega Destino" a "Bodega Origen" o desde "Maxisacos Seleccionados" hacia "Maxisacos Obtenidos", se desmarca el maxisaco y se le da click a la flechita azul que apunta hacia la izquierda `},
                        {   tipo:`label`,   texto:`- Finalmente con el botón grabar se guarda el Movimiento`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarBodegas(){
            let url = `${this.base_url}bodegas`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.bodegasOrigen = this.bodegas.filter(b => b.id == 1) ;
                this.bodegasDestino = this.bodegas.filter(b => b.id == 0) ;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarMotivos(){
            await this.axios.get(`${this.base_url}movimiento/motivos`,this.headers).then((res)=>{
                let resp = res.data.data;
                this.motivos = resp.filter(b => b.tipo == 'Reproceso');
            }).catch((e)=>{
                console.log(e);
            });
        },
        async cargarTipos(){
            await this.axios.get(`${this.base_url}movimiento/tipos`,this.headers).then((res)=>{
                let resp = res.data.data;
                this.tipos = resp.filter(b => b.valor == 'S');
                
            }).catch((e)=>{
                console.log(e);
            });
        },

        // viene del evento generado en EncabezadoMovimientos
        setDataEncabezado(data){
            this.bodega_origen = data.bodega_origen
            this.bodega_destino = data.bodega_destino
            this.fecha = data.fecha
            this.tipo = data.tipo
            this.motivo = data.motivo
            this.datos_adicionales = data.datos_adicionales
        },

        // viene del evento generado en EncabezadoMovimientos
        cargarLotes(datita){
            this.lotes = datita.lotes;
            this.lote = datita.lote;
        },

        // viene del evento generado en EncabezadoMovimientos
        cargarMaxisacos(data){
            this.setDataEncabezado(data)
            this.maxisacos_lote = data.maxisacos_lote;
        },

        // viene del evento generado en EncabezadoMovimientos
        cargarDocumentos(data){
            this.setDataEncabezado(data)
            this.documentos = data.documentos;
            this.datos_adicionales = data.datos_adicionales;
        },

        // viene del evento generado en MaxisacosSalida
        setLotesSalientes(datita){
            this.lotesSalientes = datita;
        },

        async cargarMaxisacosLote($event){
            //this.mostrarLoading('Cargando Maxisacos...');
            this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'})

            let url = `${this.base_url}jumbos/disponibles_salida/${$event.id}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.maxisacos = res.data.data;
                /**quitar jumbos que ya estan en la lista del camion*/
                let jumbitos = this.maxisacos.filter(j=>{
                    let idx = this.maxisacos_agregados.findIndex(ju=>ju.id == j.id);
                    return idx == -1 ? true : false;
                })
                this.maxisacos = jumbitos;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async traerMaxisacosLote(){
            let find_lote = this.traer_lote;
            this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'});
            let url = `${this.base_url}jumbos_lote/${find_lote}`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.maxisacos_lote.push( res.data.lote );
                this.maxisacos = res.data.data;
                /**quitar jumbos que ya estan en la lista del camion*/
                let jumbitos = this.maxisacos.filter(j=>{
                    let idx = this.maxisacos_agregados.findIndex(ju=>ju.id == j.id);
                    return idx == -1 ? true : false;
                })
                this.maxisacos = jumbitos;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async agregar_maxisaco(){
            let agregar = this.maxisacos.filter(j => j.switch == true);
            let restantes = this.maxisacos.filter(j => j.switch != true);
            let index_lote = this.maxisacos_lote.findIndex(l => l.id == this.maxisaco.id);
            this.$set(this.maxisacos_lote[index_lote], 'jumbos', restantes);
            this.maxisacos = restantes;
            this.maxisacos_obtenidos = this.maxisacos_obtenidos.concat(agregar);
            this.checkbox_select = false;
        },

        async quitarMaxi(){
            let jumbos_quitar = this.maxisacos_obtenidos.filter(j => j.switch == false);
            this.maxisacos_obtenidos = this.maxisacos_obtenidos.filter(j => j.switch == true);
            jumbos_quitar.forEach(jq => {
                let lote = this.maxisacos_lote.filter(ml => {
                    return ml.id == jq.lotes_id
                })[0];
                lote.jumbos.push(jq);
            });
        },

        setearJumbos($event){
            this.checkbox_select = false;
        },
        
        async generarSalida(){
            let errors = [];
            let infos = [];
            this.datos_adicionales.forEach(da => {
                let info = {
                    mov_documentos_id: da.mov_documentos_id,
                    valor_dato: da.valor_dato,
                    valor_fecha: da.valor_fecha,
                };
                infos.push(info);
            });
            (((this.bodega_origen === null) || (this.bodega_origen == '')) && (this.bodega_origen !== 0)) ? errors.push("Falta Bodega de Origen") : null;
            (((this.bodega_destino === null) || (this.bodega_destino == '')) && (this.bodega_destino !== 0)) ? errors.push("Falta Bodega de Destino") : null;
            !this.fecha ? errors.push("Falta fecha de la salida") : null;
            !this.tipo ? errors.push("Falta tipo") : null;
            !this.motivo ? errors.push("Falta motivo") : null;

            let detalles = [];
            this.lotesSalientes.forEach(ls => {
                ls.jumbos.forEach(j => {
                    detalles.push({jumbo_id: j.id, observacion: '.'});
                });
            });
            if(detalles.length == 0){
                errors.push("Debe indicar jumbos que salieron a reproceso");
            }
            let jumbitos = [];
            this.maxisacos_obtenidos.forEach(mo => {
                jumbitos.push(mo);
            });
            if(jumbitos.length == 0){
                errors.push("Debe indicar jumbos obtenidos en el reproceso");
            }
            let cambios = [];
            detalles.forEach(d => {
                cambios.push({id: d.jumbo_id, bodega_destino: this.bodega_destino});
            });
            //console.log(cambios);
            if(errors.length > 0){
                console.log(errors);
                this.errorMessage(errors, "Falta Información");
                return;
            }
            //this.mostrarLoading('Generando Salida ...');
            this.mostrarLoading({titulo:'Generando Salida...',color:'green'})

            let data = {
                infos: infos,
                movimiento: {
                    fecha: this.fecha,
                    tipo_movimiento: this.tipo,
                    motivo_movimiento: this.motivo,
                    bodega_origen: this.bodega_origen,
                    bodega_destino: this.bodega_destino,
                },
                detalles: detalles,
                jumbos: jumbitos,
                cambios: cambios
            }
            let url = `${this.base_url}movements`;
            await this.axios.post(url, data, this.headers).then((res)=>{
                console.log(res.data);
                this.maxisacos_obtenidos = [];
                this.jumbos_repaso = [];
                this.lote = {};
                this.jumbos = [];
                this.maxisaco = {};
                this.maxisacos = [];
                this.datos_adicionales.forEach(da => {
                    da.valor_dato = '';
                });
                this.ocultarLoading();
                this.mostrarLoading({titulo:res.data.respuesta,color:'green'})
            }).catch((error)=>{
                this.ocultarLoading();
                console.log('error',error);
                this.errorMessage(error, "No se grabó La salida");

                //this.ocultarLoading();
            });
        },

        seleccionarTodosRepaso(){
            if(this.all_repaso){
                this.maxisacos.forEach(j => {
                    j.switch = true;
                });
            }else{
                this.maxisacos.forEach(j => {
                    j.switch = false;
                });
            }
        },
        
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        lotesCamion(){
            /**retorna el id y nombre de los lotes distintos */
            let lotes = Array.from( new Set(this.maxisacos_obtenidos.map(j=>j.lotes_id)))
                    .map(id => {
                        return{
                            id:id,
                            todos:true,
                            nombre_lote: this.lotes.find(l => l.id === id).nombre_lote,
                            jumbos: this.maxisacos_obtenidos.filter(j => j.lotes_id == id).map(
                                j => {
                                    return {
                                        id:j.id,
                                        nro_jumbo:j.nro_jumbo,
                                        lotes_id:j.lotes_id,
                                        switch:j.switch
                                    }
                                }
                            ).sort((a,b)=>a.nro_jumbo - b.nro_jumbo)
                        }
                    });
            return lotes;
        },
        
        
        maxisacos_agregados(){
            let jbs = [];
            this.lotesCamion.forEach(l => {
                l.jumbos.forEach(j => {
                    jbs.push(j)
                });
            });
            return jbs;
        },

        kilos_obtenidos(){
            return this.maxisacos_obtenidos.reduce((suma_parcial, valor) => suma_parcial + valor.peso,0);
        },
        
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda':ModalAyudas,
        EncabezadoMovimientos,
        MaxisacosSalida,
    }
}
</script>
<style scoped>
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }
    .mx-datepicker{
        width: 100% !important;
    }
    .inputcito{
        border:1px solid #ccc;
        margin:0.5em 0.5em;
    }
</style>